import {
    EDITDEALERLIST_SUCCESS,
    EDITDEALERLIST_FAILED,
    RESET_EDITDEALERLIST,
    LOADING_EDITDEALERLIST,
    NETWORK_ERROR_EDITDEALERLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_EDITDEALERLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case EDITDEALERLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case EDITDEALERLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_EDITDEALERLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_EDITDEALERLIST:
            return (state = initialState);
        default:
            return state;
    }
};